import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import css from './StepProgress.module.scss';

export type DrawerStep = 'upload' | 'confirm' | 'review' | 'plan';

const STEPS: { key: DrawerStep; label: string }[] = [
  { key: 'upload', label: 'Upload' },
  { key: 'confirm', label: 'Details' },
  { key: 'review', label: 'Feedback' },
  { key: 'plan', label: 'Coverage' },
];

interface StepProgressProps {
  current: DrawerStep;
}

/**
 * Persistent progress indicator pinned in the drawer header so the user always
 * knows where they are in the Upload → Details → Feedback → Coverage flow.
 */
const StepProgress: React.FC<StepProgressProps> = ({ current }) => {
  const currentIndex = STEPS.findIndex((s) => s.key === current);

  return (
    <nav className={css.steps} aria-label="Progress">
      <ol className={css.list}>
        {STEPS.map((step, i) => {
          const state =
            i < currentIndex ? 'done' : i === currentIndex ? 'active' : 'upcoming';
          return (
            <React.Fragment key={step.key}>
              {i > 0 && (
                <span
                  aria-hidden="true"
                  className={`${css.connector} ${
                    i <= currentIndex ? css.connectorDone : ''
                  }`}
                />
              )}
              <li
                className={`${css.step} ${css[state]}`}
                aria-current={state === 'active' ? 'step' : undefined}
              >
                <span className={css.marker}>
                  {state === 'done' ? <CheckOutlined /> : i + 1}
                </span>
                <span className={css.stepLabel}>{step.label}</span>
              </li>
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export default StepProgress;
